import { render } from "./Sale-History.vue?vue&type=template&id=f2d0e846"
import script from "./Sale-History.vue?vue&type=script&lang=js"
export * from "./Sale-History.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__